import { Component } from '@angular/core';

@Component({
    selector: 'app-main-page',
    templateUrl: './main-page.component.html',
    styleUrls: ['./main-page.component.scss'],
    standalone: false
})
export class MainPageComponent {
  overlayStatus: boolean;

  getOverlayStatus(event) {
    this.overlayStatus = event;
  }
}
